__turbopack_context__.v({
  "image": "ZbLpVG_image",
});
